export default __webpack_public_path__ + "static/media/agriculture.be5d4c57.png";